import React from "react";
import { Assets } from "../../assets";
import { useUiRedux } from "../../hooks/useUiRedux";
import { menuSelect } from "../../types/initStore/initUi";

export const HeaderLogo = () => {
	const { backMenu, state } = useUiRedux();
	return (
		<>
			<div
				className="absolute z-10 lg:top-7 lg:left-10 cursor-pointer"
				onClick={() => {
					if (state.menuSelect !== menuSelect.principal) {
						backMenu();
					}
				}}
			>
				<div className="flex gap-2">
					<div className="flex justify-center items-center flex-col gap-2 text-white">
						<div className="w-[60px]">
							<img className="w-full h-full" src={Assets.general.logo} alt="logo" />
						</div>
						<span className="text-[12px] arialFont">Casa abierta al tiempo</span>
					</div>
					<div className="flex gap-2">
						<div className="h-full w-0.5 bg-white opacity-50" />
						<div className="flex flex-col text-white">
							<span className="uppercase text-[12px] arialFont">UNIVERSIDAD </span>
							<span className="uppercase text-[12px] arialFont">AUTÓNOMA</span>
							<span className="uppercase text-[12px] arialFont">METROPOLITANA</span>
							<span className="capitalize text-[12px] arialFont">Unidad xochimilco</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
